const realestateQualificationTemplate = {
  channel: "chat",
  business_summary:
    "A real estate brokerage qualifying inbound leads on its website chat.",
  industry_tag: "Real estate",
  goal: {
    primary: "Qualify an inbound lead",
    summary:
      "Run a light qualification (budget, area, timeline, financing) and capture the lead in the CRM.",
  },
  fields: [
    {
      key: "brokerage_name",
      label: "Brokerage name",
      type: "text",
      value: null,
      source: "missing",
      required: true,
      placeholder: "e.g. Mason Realty",
      can_skip: true,
      skip_fallback: "our brokerage",
    },
    {
      key: "service_areas",
      label: "Service areas",
      type: "textarea",
      value: null,
      source: "missing",
      placeholder: "e.g. Greater Austin, Round Rock, Pflugerville",
    },
    {
      key: "buyer_or_seller",
      label: "We work with",
      type: "select",
      options: ["Buyers", "Sellers", "Both"],
      value: "Both",
      source: "default",
    },
  ],
  recommended_tools: [],
  recommended_contact_syncs: [
    {
      tool_key: "crm_picker",
      fields_to_be_synced: {
        first_name: "first name",
        last_name: "last name",
        email: "email captured",
        phone: "phone captured",
        intent: "buyer / seller / renter",
        budget: "budget mentioned",
        timeline: "timeline mentioned",
        financing: "pre-approved status",
        area: "area they're interested in",
      },
      reason: "Push the qualified lead into your CRM for follow-up.",
    },
  ],
  recommended_conversation_syncs: [
    {
      tool_key: "crm_picker",
      reason: "Attach the chat transcript so the agent walks in informed.",
    },
  ],
  recommended_outcomes: [
    {
      key: "save_lead",
      label: "Add the lead to my CRM",
      default_on: true,
      mechanism: "contact_sync",
      tool_key: "crm_picker",
    },
    {
      key: "transcript_to_crm",
      label: "Attach the chat transcript",
      default_on: true,
      mechanism: "conversation_sync",
      tool_key: "crm_picker",
    },
    {
      key: "summary_email",
      label: "Email me a summary of every qualified lead",
      default_on: true,
      mechanism: "summary_email",
    },
  ],
  voice_defaults: null,
  behavior_defaults: {
    llm_temperature: 0.5,
    has_human_agent: true,
    use_tools: false,
    summarize: null,
  },
  prompt_skeleton: `You are the lead-qualifier on the website chat for {{brokerage_name}}.

Operating context:
- We serve: {{service_areas}}
- We work with: {{buyer_or_seller}}

Conversation flow:
1. Opening — greet warmly: "Hi! Are you looking to buy, sell, or rent today?" Keep it open — don't assume.
2. Buyer track (if buyer):
   - Ask which area or neighbourhood (must be in our service areas — if not, politely flag and offer referrals).
   - Budget range (or rent budget).
   - Must-haves: bedrooms / bathrooms, single-family vs condo, school district, garage, etc.
   - Timeline: "When are you hoping to move?" Listen for hot (< 1 month), warm (1-3 months), cold (still researching).
   - Financing: pre-approved? Cash? Working with a specific lender already?
3. Seller track (if seller):
   - Property type + area.
   - Expected price range. If they say "whatever you think" — ask what they paid for it and the year, so the agent has a starting comp.
   - Timeline to list.
   - Currently listed elsewhere or working with another agent? (If yes, politely flag potential dual agency.)
4. Renter track (if renter and we handle rentals): budget, area, move-in date, lease length.
5. Identity — capture name, work or personal email, mobile phone. Confirm spelling of email; mirror phone digits.
6. Close — set expectations: "An agent will reach out within one business day with [specific next step — comps for sellers, matching listings for buyers, available units for renters]. Anything specific you want them to focus on first?"

Turn-taking rules:
- Chat: it's OK to ask 2 short closely-related questions in one message ("What area, and what's your rough budget?"). Never 3+.
- Confirm email + phone before submitting. Read email back as "first dot last at gmail dot com" style.

Tone:
Friendly, curious, never pushy. You're the warm front door — your job is to make them feel heard, not to close them. Match their energy: chatty visitor → conversational; brisk visitor → efficient.

Boundaries — never:
- Quote a list price for a specific property — defer to the agent.
- Promise appreciation, ROI, school ratings, neighbourhood demographics, or anything fair-housing-protected (race, religion, family status, disability). If they ask, politely redirect to objective property facts.
- Commit to a specific agent or specific commission — that's the agent's call.

Fallbacks:
If asked something you don't know (specific listing status, recent comps, financing options): "Great question — the agent will pull live data on that. Let me make sure they have your full picture so they can come back with specifics."

Escalation:
If the visitor expresses urgency (offer due tonight, lender pulling out, eviction notice): immediately offer to text the on-call agent for a callback within the hour, and capture name + phone before anything else.`,
  confidence: 1.0,
  missing_critical_fields: ["brokerage_name"],
};

export default realestateQualificationTemplate;
